module.exports = __webpack_public_path__ + "img/homepage-strip-banner-default.cb3cc827.jpg";